import { MarkdownContent } from '@ping/components/MarkdownContent';

interface ICampaignLegalMarkdownProps {
  content: string;
  className?: string;
}

export const CampaignLegalMarkdown = ({ content, className }: ICampaignLegalMarkdownProps) => (
  <MarkdownContent content={content} variant='legal' className={className} />
);
